<template>
  <div v-if="showModal" class="fixed inset-0 w-full h-full z-99 card-bg duration-300 overflow-y-auto" @click.self="closeWindows">
    <div class="w-full sm:5/12 sm:pt-14 md:w-6/12 lg:w-4/12 px-4 mx-auto pt-8 pscenter">
      <div class="relative bg-white flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
        <div @click="closeWindows">
          <img class="float-right cursor-pointer p-6" src="@/assets/img/close.png" alt="close" />
        </div>
        <!-- 動態載入元件 -->
        <div :is="modalContent"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import Register from '@/components/Register/Register';
import Login from '@/components/Login/Login';
import LaleQRcode from '@/components/Login/LaleQRcode';
export default {
  name: 'Modal',
  components: {
    Register,
    Login,
    LaleQRcode
  },
  data() {
    return {
      modalContent: ''
    };
  },
  computed: {
    ...mapState(['showModal', 'modalType'])
  },
  watch: {
    modalType() {
      this.checkModalType();
    }
  },
  created() {
    this.checkModalType();
  },
  methods: {
    ...mapMutations(['SET_SHOW_MODAL']),
    // 判斷要顯示什麼內容的 modal
    checkModalType() {
      switch (this.modalType) {
        case 'login':
          this.modalContent = 'login';
          break;
        case 'Register':
          this.modalContent = 'Register';
          break;
        case 'laleQRcode':
          this.modalContent = 'laleQRcode';
          break;
        default:
          break;
      }
    },
    closeWindows() {
      this.SET_SHOW_MODAL(false);
    }
  }
};
</script>

<style scoped lang="scss">
.z-99 {
  z-index: 999;
}
.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}
.w-11 {
  width: 2.75rem /* 44px */;
}
.absolute {
  position: absolute;
}
.fixed {
  position: fixed;
}
.flex-auto {
  flex: 1 1 auto;
}
.justify-end {
  justify-content: flex-end;
}
.text-center {
  text-align: center;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem /* 4px */;
}
.mb-3 {
  margin-bottom: 0.75rem /* 12px */;
}
.mb-6 {
  margin-bottom: 1.5rem /* 24px */;
}
.mt-3 {
  margin-top: 1rem;
}
.p-2\.5 {
  padding: 0.625rem /* 10px */;
}
.p-6 {
  padding: 1.5rem /* 24px */;
}
.pt-0 {
  padding-top: 0px;
}
.px-3 {
  padding-left: 0.75rem /* 12px */;
  padding-right: 0.75rem /* 12px */;
}
.px-4 {
  padding-left: 1rem /* 16px */;
  padding-right: 1rem /* 16px */;
}
.px-6 {
  padding-left: 1.5rem /* 24px */;
  padding-right: 1.5rem /* 24px */;
}
.py-2 {
  padding-top: 0.5rem /* 8px */;
  padding-bottom: 0.5rem /* 8px */;
}
.py-4 {
  padding-top: 1rem /* 16px */;
  padding-bottom: 1rem /* 16px */;
}
.py-10 {
  padding-top: 2.5rem /* 40px */;
  padding-bottom: 2.5rem /* 40px */;
}
.pl-10 {
  padding-left: 2.5rem /* 40px */;
}

.text-left {
  text-align: left;
}
.rounded-lg {
  border-radius: 0.5rem /* 8px */;
}
.inset-0 {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.overflow-y-auto {
  overflow-y: auto;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.float-right {
  float: right;
}
.clear-both {
  clear: both;
}
// 視窗架
.pscenter {
  position: absolute;
  z-index: 999999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.card-bg {
  background: rgba(162, 162, 162, 0.8);
}

.duration-300 {
  transition-duration: 300ms;
}

.relative {
  position: relative;
}

.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.min-w-0 {
  min-width: 0px;
}

.break-words {
  overflow-wrap: break-word;
}

.rounded-lg {
  border-radius: 0.5rem /* 8px */;
}

.cursor-pointer {
  cursor: pointer;
}

@media (min-width: 640px) {
  .sm\:pt-14 {
    padding-top: 3.5rem /* 56px */;
  }
}

@media (min-width: 768px) {
  .md\:w-6\/12 {
    width: 50%;
  }
}

@media (min-width: 1024px) {
  .lg\:w-4\/12 {
    width: 33.333333%;
  }
}
</style>
